import script from "./AdminTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTabs.vue?vue&type=script&setup=true&lang=js"

import "./AdminTabs.vue?vue&type=style&index=0&id=06a5afdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a5afdc"]])

export default __exports__